// src/i18n/es/lockers.js
const lockers = {
    name: 'Taquilla |||| Taquillas',
    title: 'Gestión de Taquillas',
    titles: {
        list: 'Taquillas',
        create: 'Nueva Taquilla',
        edit: 'Editar Taquilla',
        show: 'Detalles de Taquilla',
    },
    fields: {
        id: 'ID',
        displayNumber: 'Nº',
        display_number: 'Nº',
        hardwareId: 'ID',
        hardware_id: 'ID',
        hotel: 'Hotel',
        hotelId: 'Hotel',
        hotel_id: 'Hotel',
        zone: 'Zona',
        zoneId: 'Zona',
        zone_id: 'Zona',
        lockerType: 'Tipo',
        locker_type: 'Tipo de Taquilla',
        lockerTypeId: 'Tipo',
        lockerController: 'Controlador',
        controller: 'Controlador',
        status: 'Estado',
        statusReason: 'Motivo del estado',
        status_reason: 'Razón del Estado',
        assignment: 'Asignación',
        assignmentId: 'Asignación',
        assignment_id: 'ID de Asignación',
        assignedAt: 'Asignada el',
        assigned_at: 'Fecha de Asignación',
        reservedUntil: 'Reservada hasta',
        lastMaintenance: 'Último mantenimiento',
        last_maintenance_at: 'Último Mantenimiento',
        notes: 'Notas',
        blockReason: 'Motivo del bloqueo',
        releaseReason: 'Motivo',
        isActive: 'Activa',
        createdAt: 'Creada',
        updatedAt: 'Actualizada',
    },
    status: {
        available: 'Disponible',
        occupied: 'Ocupada',
        maintenance: 'Mantenimiento',
        outOfService: 'Fuera de servicio',
        out_of_service: 'Fuera de Servicio',
        reserved: 'Reservada',
        blocked: 'Bloqueada',
    },
    filters: {
        title: 'Filtros',
        search: 'Buscar por número o ID...',
        search_placeholder: 'Buscar taquillas...',
        status: 'Estado',
        all_status: 'Todos los estados',
        zone: 'Zona',
        all_zones: 'Todas las zonas',
        type: 'Tipo',
        all_types: 'Todos los tipos',
        hotel: 'Hotel',
        all_hotels: 'Todos los hoteles',
        available_only: 'Solo disponibles',
        occupied_only: 'Solo ocupadas',
        maintenance_only: 'En mantenimiento',
        assignment: 'Asignación',
        with_assignment: 'Con asignación',
        without_assignment: 'Sin asignación',
    },
    actions: {
        create: 'Nueva Taquilla',
        edit: 'Editar',
        delete: 'Eliminar',
        assign: 'Asignar',
        release: 'Liberar',
        maintenance: 'Mantenimiento',
        activate: 'Activar',
        deactivate: 'Desactivar',
        view_details: 'Ver detalles',
        view_history: 'Ver historial',
        bulk_assign: 'Asignar múltiples',
        bulk_release: 'Liberar múltiples',
        export: 'Exportar taquillas',
        import: 'Importar taquillas',
        block: 'Bloquear',
        unblock: 'Desbloquear',
        force_release: 'Forzar liberación',
    },
    messages: {
        no_lockers: 'No se encontraron taquillas',
        loading: 'Cargando taquillas...',
        create_success: 'Taquilla creada correctamente',
        update_success: 'Taquilla actualizada correctamente',
        delete_success: 'Taquilla eliminada correctamente',
        delete_confirm: '¿Está seguro de que desea eliminar esta taquilla?',
        assign_success: 'Taquilla asignada correctamente',
        release_success: 'Taquilla liberada correctamente',
        maintenance_success: 'Taquilla puesta en mantenimiento',
        bulk_assign_success: '%{count} taquillas asignadas correctamente',
        bulk_release_success: '%{count} taquillas liberadas correctamente',
        already_occupied: 'Esta taquilla ya está ocupada',
        not_available: 'Esta taquilla no está disponible',
        invalid_hardware_id: 'El ID de hardware no es válido',
        duplicate_number: 'Ya existe una taquilla con este número',
        block_reason_required: 'Debes indicar un motivo para bloquear la taquilla',
        block_reason_too_short: 'El motivo debe tener al menos 5 caracteres',
        block_success: 'Taquilla %{displayNumber} bloqueada correctamente',
        block_error: 'Error al bloquear la taquilla',
        unblock_success: 'Taquilla %{displayNumber} desbloqueada correctamente',
        unblock_error: 'Error al desbloquear la taquilla',
        force_release_success: 'Taquilla %{displayNumber} liberada correctamente',
        force_release_error: 'Error al liberar la taquilla',
    },
    placeholders: {
        block_reason: 'Ej: Puerta averiada, necesita mantenimiento',
        release_reason: 'Ej: Huésped se fue sin hacer checkout'
    },
    validation: {
        display_number_required: 'El número de taquilla es obligatorio',
        hardware_id_required: 'El ID de hardware es obligatorio',
        zone_required: 'La zona es obligatoria',
        invalid_status: 'Estado no válido',
        number_format: 'El número debe tener el formato correcto',
        hardware_id_format: 'El ID de hardware debe tener el formato correcto',
        reason_required: 'El motivo es obligatorio',
        minLength: 'Mínimo {{min}} caracteres',
        maxLength: 'Máximo {{max}} caracteres',
        positive: 'Debe ser un número positivo'
    },
    help: {
        title: 'Taquillas',
        description: 'Gestione las taquillas físicas del sistema.',
        feature_management: 'Gestión individual y en lote de taquillas',
        feature_status: 'Control del estado: disponible, ocupada, reservada o bloqueada',
        feature_zones: 'Organización por zonas dentro del hotel',
        feature_controllers: 'Asociación con controladores de hardware',
        displayNumber: 'Número visible de la taquilla',
        hardwareId: 'Identificador único del hardware',
        notes: 'Observaciones adicionales sobre la taquilla',
    },
    sections: {
        basic_info: 'Información Básica',
        basic_info_subtitle: 'Datos principales de la taquilla',
        info: 'Información adicional',
        create: 'Crear Taquilla',
        create_subtitle: 'Ingrese los datos de la nueva taquilla'
    },
    warnings: {
        occupied_edit: 'Esta taquilla está ocupada. Algunos campos no se pueden modificar mientras esté en uso.'
    },
    errors: {
        update: 'Error al actualizar la taquilla'
    },
    dialogs: {
        delete_title: 'Eliminar Taquilla',
        delete_message: '¿Estás seguro de que deseas eliminar la taquilla?',
        delete_warning: 'Esta acción no se puede deshacer. La taquilla quedará marcada como inactiva.',
        release_title: 'Liberar Taquilla',
        release_message: '¿Está seguro de que desea liberar la taquilla %{number}?',
        maintenance_title: 'Poner en Mantenimiento',
        maintenance_message: '¿Desea poner la taquilla %{number} en mantenimiento?',
        maintenance_reason: 'Motivo del mantenimiento',
        block_title: 'Bloquear taquilla %{displayNumber}',
        force_release_title: 'Forzar liberación de taquilla %{displayNumber}',
    },
    tooltips: {
        available: 'Esta taquilla está disponible para asignar',
        occupied: 'Esta taquilla está actualmente asignada',
        maintenance: 'Esta taquilla está en mantenimiento',
        out_of_service: 'Esta taquilla está fuera de servicio',
        view_assignment: 'Ver detalles de la asignación actual',
    },
    bulk: {
        title: 'Operaciones masivas',
        selected: '%{count} taquillas seleccionadas',
        assign_title: 'Asignar taquillas seleccionadas',
        release_title: 'Liberar taquillas seleccionadas',
        maintenance_title: 'Poner en mantenimiento',
        confirm_assign: '¿Asignar %{count} taquillas?',
        confirm_release: '¿Liberar %{count} taquillas?',
        confirm_maintenance: '¿Poner %{count} taquillas en mantenimiento?',
    },
    batch: {
        title: 'Crear Taquillas en Lote',
        subtitle: 'Crea múltiples taquillas con numeración consecutiva',
        mode_label: 'Modo de creación',
        mode_single: 'Una taquilla',
        mode_batch: 'Varias taquillas',
        numbering: 'Numeración',
        prefix: 'Prefijo',
        prefix_help: 'Opcional. Ej: A, B, ZONA1',
        start_number: 'Número inicial',
        end_number: 'Número final',
        end_must_be_greater: 'Debe ser mayor o igual al número inicial',
        start_hardware_id: 'ID hardware inicial',
        start_hardware_id_help: 'ID del controlador para la primera taquilla',
        location: 'Ubicación',
        preview: 'Vista previa',
        preview_subtitle: 'Se crearán %{count} taquillas',
        no_preview: 'Ajusta los números para ver la vista previa',
        more: 'más',
        large_batch_warning: 'Vas a crear %{count} taquillas. Esta operación puede tardar un momento.',
        notes_placeholder: 'Notas opcionales para todas las taquillas del lote',
        creating: 'Creando taquillas...',
        created: 'creadas',
        failed: 'fallidas',
        create_button: 'Crear %{count} taquillas',
        success: '%{count} taquillas creadas correctamente',
        partial_success: '%{created} taquillas creadas, %{errors} con errores',
        error_no_lockers: 'No hay taquillas para crear. Ajusta la numeración.',
    },
    notifications: {
        updated: 'Taquilla actualizada correctamente'
    },
    helpers: {
        block_reason: 'Especifique el motivo por el cual se está bloqueando esta taquilla',
        block_reason_optional: 'Opcionalmente, especifique el motivo del bloqueo (recomendado para trazabilidad)',
        release_reason_optional: 'Opcionalmente, especifique el motivo de la liberación (recomendado para trazabilidad)'
    },
    assignment_info: {
        available: 'Disponible',
        assigned: 'Asignado',
        today: 'Hoy',
        yesterday: 'Ayer',
        days_ago: 'Hace %{count} días',
        weeks_ago: 'Hace %{count} semanas',
        months_ago: 'Hace %{count} meses',
        reference: 'Referencia',
        assignment_id: 'ID Asignación',
        room: 'Habitación',
        guest: 'Huésped',
        status: 'Estado',
        assigned_at: 'Asignado',
        time_assigned: 'Tiempo asignado',
        user: 'Usuario',
        room_number: 'Habitación %{number}',
    }
};

export default lockers;